export enum JobStatus {
  complete = "complete",
  failed = "failed",
  inProgress = "in-progress",
  pending = "pending",
}
